export default "__VITE_ASSET__ae6d7734__"